import { Reveal } from './Reveal';

// SectionHeading enforces a consistent editorial hierarchy throughout the page.
export function SectionHeading({ kicker, title, intro, light = false }) {
  return (
    <Reveal className="section-heading">
      <p className={`eyebrow ${light ? 'eyebrow--light' : ''}`}>{kicker}</p>
      <h2 className="display-title max-w-5xl">{title}</h2>
      {intro && <p className="section-intro">{intro}</p>}
    </Reveal>
  );
}
